/**
* @file Column component for displaying a item with info about the start and if the item is currently active
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import * as moment from 'moment';
import { LocalisationService } from '../../../core/localisation.service';
import { durationToText } from '../../../core/helpers/durationToText';
import { TranslateService } from '@ngx-translate/core';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * Column component for displaying info about start and active (locations, departments, competences, teams)
 */
var ColumnStartActiveComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnStartActiveComponent, _super);
    /**
     * Constructs a ColumStartActiveComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnStartActiveComponent(provider, changeDetector, translateService, localisationService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.localisationService = localisationService;
        // The root entity of the column
        _this.root = _this.provider.root;
        _this.html5RoleLabels = undefined;
        var labels = [
            'APP.MISC.ROLES.SYMAGIC',
            'APP.MISC.ROLES.ADMINISTRATOR',
            'APP.MISC.ROLES.MANAGER',
            'APP.MISC.ROLES.PLANNER',
            'APP.MISC.ROLES.EMPLOYEE'
        ];
        _this.setHTML5RoleLabels(labels, translateService);
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnStartActiveComponent.register = function () {
        ComponentRegistry.register('column', 'start-active', ColumnStartActiveComponent);
    };
    /**
     * Sets the HTML5 role labels.
     * @private
     * @param {string[]} labels The labels are translated.
     * @param {TranslateService} translateService Is used to translate.
     * @memberOf ColumnStartActiveComponent
     */
    ColumnStartActiveComponent.prototype.setHTML5RoleLabels = function (labels, translateService) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, translateService.get(labels).toPromise()];
                    case 1:
                        _a.html5RoleLabels = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * The start of given item
     */
    ColumnStartActiveComponent.prototype.getStart = function () {
        // Todo: Start is part of State?
        var operational = this.root['Operational'];
        if (operational) {
            return moment(operational);
        }
        return moment(this.root['Start']);
    };
    /**
     * Gets Value of property and formats when needed.
     * @returns {string} The value of the displayed property.
     */
    ColumnStartActiveComponent.prototype.getValue = function () {
        if (this.provider.field.name === 'ContractHours') {
            return durationToText(moment.duration(this.provider.value));
        }
        var html5Role = this.provider.root ? this.provider.root['HTML5Role'] : null;
        if (html5Role && this.html5RoleLabels) {
            return this.provider.value + ' - ' + this.html5RoleLabels['APP.MISC.ROLES.' + html5Role];
        }
        return this.provider.value;
    };
    /**
     * Is item active
     */
    ColumnStartActiveComponent.prototype.isActive = function () {
        var active = this.root['Active'];
        if (active != null) {
            return active;
        }
        // Todo: Active is part of State?
        return false;
    };
    return ColumnStartActiveComponent;
}(ColumnBase));
export { ColumnStartActiveComponent };
